export default {"src":"/_next/static/media/document.ff8e139a.svg","height":90,"width":89};